export default function findAltText(name, title) {
  let altToReturn = 'alt text not set';
  const translations = window.campaign_data.campaign_translations.blocks;

  const altTranslationBlock =
    translations[`alt${name.split(' ').join().toLowerCase()}`];
  if (
    altTranslationBlock !== undefined &&
    altTranslationBlock !== '' &&
    altTranslationBlock !== null
  ) {
    altToReturn = altTranslationBlock;
  } else if (title !== undefined && title !== '' && title !== null) {
    altToReturn = title;
  } else {
    altToReturn = window.campaign_data.campaign_translations.title;
  }
  return altToReturn;
}
